export default "__VITE_ASSET__D_85vo4h__"